import { render, staticRenderFns } from "./KycProviderPage.vue?vue&type=template&id=95a24f64&"
import script from "./KycProviderPage.vue?vue&type=script&lang=js&"
export * from "./KycProviderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports